import React, { useState } from "react";
import { Button } from "@mui/material";
import BoxKit from "../../kit/box";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CardBoxLayout from "@/modules/user/layout/cardBoxLayout";
import CustomButton from "../../kit/button";
type TabItem = {
  label: string;
  content: React.ReactNode;
  disabled?: boolean;
  successText?: React.ReactNode | "";
};

type Props = {
  tabs: TabItem[];
  disabled?: boolean;
  successTab?: boolean;
  activeTab?: number;
  successSecondTab?: boolean;
  contentFinalTab?: React.ReactNode;
  validationStatus?: boolean;
  contentValidation?: React.ReactNode;
  isContent?: boolean;
};

const CustomTabs = ({
  tabs,
  disabled,
  successTab,
  activeTab = 0,
  successSecondTab,
  contentFinalTab,
  validationStatus,
  contentValidation,
  isContent,
}: Props) => {
  return (
    <BoxKit sx={{ width: "100%", height: "100%", color: "white" }}>
      <BoxKit sx={{ display: "flex", gap: 1, mr: 2 }}>
        {tabs.map((tab, index) => {
          return tab.label.trim() !== "" ? (
            <CustomButton
              key={index}
              variant={activeTab === index ? "contained" : "text"}
              sx={{
                fontWeight: "bold",
                background: " #fff !important",
                color:
                  activeTab === index
                    ? "white"
                    : successTab
                      ? "#00CE15"
                      : "#ccc",
                border: activeTab === index ? "none" : "1px solid #444",
                paddingX: "16px",
                transition: "all 0.3s ease",
                borderTopLeftRadius: "10px",
                borderTopRightRadius: "10px",
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,

                gap: 1,
              }}
              disabled={tab?.disabled ? tab?.disabled : false}
            >
              {successTab && activeTab !== index && !tab.disabled ? (
                <CheckCircleOutlineIcon sx={{ color: "#00CE15" }} />
              ) : null}
              {tab.label}
            </CustomButton>
          ) : null;
        })}
      </BoxKit>

      {/* Tabs Content */}
      <CardBoxLayout>
        {!successSecondTab || !isContent
          ? tabs[activeTab]?.content
          : validationStatus
            ? contentValidation
            : contentFinalTab}
      </CardBoxLayout>
    </BoxKit>
  );
};

export default CustomTabs;
